export interface INetworks {
    networkId: string;
    nameEnglish: string;
    nameArabic: string;
    codeEnglish: string;
    codeArabic: string;
    descriptionEnglish: string;
    descriptionArabic: string;
    deleted: boolean;
    createdBy: string;
    createdDate: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    deletedBy: string;
    deletedDate: string;
    erpNetworkId?: string;
}

export interface INetworkDetails {
    networkId: string;
    nameEnglish: string;
    nameArabic: string;
    codeEnglish: string;
    codeArabic: string;
    descriptionEnglish: string;
    descriptionArabic: string;
    erpNetworkId?: string;
}

export const networkConfig = {
    entityName: 'CONFIGURATION.NETWORK.TITLE',
    codeEnglish: 'CONFIGURATION.NETWORK.ENGLISH_CODE',
    nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
    descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
    codeArabic: 'CONFIGURATION.NETWORK.ARABIC_CODE',
    nameArabic: 'FORM_FIELD.ARABIC_NAME',
    descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION'
};

